<template>
    <div class="c-dashboard-quick-controls"
        :data-component-name="$options.name"
    >
        <!-- <div class="c-dashboard-quick-controls__icon"> -->
        <div class="c-dashboard-quick-controls__icon cursor-pointer" @click="$emit('new-project', true)">
            <SvgIcon name="add" />
        </div>
        <!-- <div class="c-dashboard-quick-controls__buttons">
            <button class="o-button-circle -client">
                <SvgIcon name="industry" />
            </button>
            <button class="o-button-circle -staff">
                <SvgIcon name="contact" />
            </button>
            <button class="o-button-circle -project"
                @click="$emit('new-project', true)"
            >
                <SvgIcon name="project" />
            </button>
        </div> -->
    </div>
</template>

<script>
    export default {
        name: 'FloatingControls',
        components: {
        },
        data(){
            return {
                newProject: false
            }
        },
        mounted(){
            window.addEventListener("keypress", function(e) {
                if(e.key === 'n' && e.ctrlKey) this.$emit('new-project', true)
            }.bind(this));
        }
    }
</script>
